import React, { useContext, useEffect, useState } from "react";
import { Space, Button, Input, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useLocation, Redirect } from "react-router-dom";
import { Xpagination, Xtable, XtagTable } from "../../component/Xcomponent";
import _ from "lodash";
import axios from "axios";
import { getDoctorToken } from "../../utils";
import { getPatientName } from "b2c6a1a8wq-ak/dist/helper/commonHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import config from "../../config"
import { connect } from "react-redux";
import HeaderContext from "../../context/HeaderContext";
// action

const DoctorDtrfDashboard = (props) => {

  const {
    getDoctorDetailState,
  } = props;
  // drawer
  const history = useHistory();
  const search = useLocation().search;
  const [redirect, setRedirect] = useState(["", false]);
    const [loadingTableData, setLoadingTableData] = useState(false)
    const page = new URLSearchParams(search).get("page");
  const [searchText, setSearchText] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
  });
  const {setTitle} = useContext(HeaderContext);
    setTitle("DTRF Dashboard");
  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "name",
      render: (createdAt) => {
        return <span>{moment(createdAt).format("DD-MM-YYYY")}</span>;
      },
    },
    ,
    {
      title: "Institute Name",
      dataIndex: "institute_name",
      key: "name",
      render: (institute_name) => {
        return <span>{institute_name}</span>;
      },
    },
    {
      title: "Patient Name",
      dataIndex: "",
      key: "name",
      render: (dtrf) => {
        return dtrf.patient[0]
          ? getPatientName(
              dtrf.patient[0],
              dtrf.test_info.flow == "4" ? true : false
            )
            ? getPatientName(
                dtrf.patient[0],
                dtrf.test_info.flow == "4" ? true : false
              )
            : "No name"
          : "No name";
      },
    },
    {
      title: "Doctor Name",
      dataIndex: "",
      key: "name",
      render: (dtrf) => {
        return (
          dtrf.doctor_info.doctorName.fname +
          " " +
          dtrf.doctor_info.doctorName.lname
        );
      },
    },
    {
      title: "Test Name",
      dataIndex: "test_info",
      key: "test_info",
      render: (test_info) => {
        return <span>{test_info.display_test_name}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        return <Tag color={getColor(status.status)}>{status.status}</Tag>;
      },
    },
  ];
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getData(pagination);
  }, []);
  
  const getColor = (statusObject) => {
    const status = statusObject? statusObject.toUpperCase() :"";
    if (status == "COMPLETE") {
      return "green";
    } else if (status == "PENDING") {
      return "volcano";
    } else if (status == "ABANDONED") {
      return "red";
    } else if (status == "FAILED") {
      return "red";
    } else return "geekblue";
  };

  const getData = (pageFilter) => {
    
    const url = `${config.dtrf.getDtrfs}?page=${pageFilter.page}&&pageSize=${pageFilter.pageSize}`;
    setLoadingTableData(true)
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${getDoctorToken()}`,
        },
      })
      .then((res) => {
        console.log(res);
        setLoadingTableData(false)
        setDataSource(res.data.data.data);
        setPagination(res.data.data.pagination);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({
      ...searchText,
      [dataIndex]: selectedKeys[0],
    });
  };

  const handleReset = (clearFilters, dataIndex) => {
    let remainSearch = _.omit(searchText, [dataIndex]);
    clearFilters();
    setSearchText(remainSearch);
  };

  const getColumnSearchProps = (dataIndex, name) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${name}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => [
            handleSearch(selectedKeys, confirm, dataIndex),
            setPagination({ ...pagination, ["page"]: 1 }),
          ]}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => [
              handleSearch(selectedKeys, confirm, dataIndex),
              setPagination({ ...pagination, ["page"]: 1 }),
            ]}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90}}
          >
            Search
          </Button>
          <Button
            className="borderNonPrimary"
            onClick={() => handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
  });

  return (
    <>
      {
        getDoctorDetailState.apiState=="success" && getDoctorDetailState.data.is_dtrf_activated=="Yes" ? 
        <>
          <div>
            <Button
              className="mb-3 borderPrimary"
              type="primary"
              onClick={() => {
                getData({ ...pagination, page: pagination.page, pageSize: pagination.pageSize });
              }}
            >
              Try again
            </Button>
          </div>
          <Xtable
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  return history.push({
                    pathname: "/dtrf/" + record._id,
                    state: record._id,
                  });
                }, // click row
                onDoubleClick: (event) => {}, // double click row
                onContextMenu: (event) => {}, // right button click row
                onMouseEnter: (event) => {
                  event.currentTarget.classList.add('pointer-cursor');
                },
                onMouseLeave: (event) => {
                  event.currentTarget.classList.remove('pointer-cursor');
                },
              };
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            scroll={{ x: 768 }}
            loading={loadingTableData}
          />
          <Xpagination
            style={{gap:"5px",flexWrap:"wrap"}}
            pageSizeOptions={["25", "50", "100", "500"]}
            showSizeChanger
            total={pagination.total_records}
            onChange={(page, pageSize) => {
              //   setPagination({ page: page, pageSize: pageSize });
              getData({ ...pagination, page: page, pageSize: pageSize });
            }}
            current={pagination.page}
            defaultPageSize={pagination.pageSize}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
          />
        </>
        :
        <h6>Access Not Authorized</h6>
      }
    </>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DoctorDtrfDashboard);
